import {v4} from 'uuid';

export class ViberCarouselItemDataObject {
	/**
	 * @param {?string} [id=null] - DB ID of the carousel item.
	 * @param {string} [title=''] - Title of the carousel item.
	 * @param {string} [image=''] - Image URL of the carousel item.
	 * @param {number} ordinal - Ordinal of the carousel item.
	 * @param {ViberCarouselItemButtonDataObject[]} buttons - Buttons of the carousel item. For now, the provider 
	 * supports exactly 2 buttons.
	 */
	constructor(
		id = null, 
		title = '', 
		image = '', 
		buttons = [
			new ViberCarouselItemButtonDataObject(undefined, undefined, undefined, 1),
			new ViberCarouselItemButtonDataObject(undefined, undefined, undefined, 2),
		],
		ordinal = 1,
	) {
		this.id = id;
		this.title = title;
		this.image = image;
		this.buttons = buttons;
		this.ordinal = ordinal;
		
		this.GUIID = v4();
	}
}

export class ViberCarouselItemButtonDataObject {
	/**
	 * @param {?string} id - DB ID of the carousel item button.
	 * @param {string} label - Label of the carousel item button.
	 * @param {string} action - Action URL of the carousel item button.
	 * @param {number} ordinal - Ordinal of the carousel item button.
	 */
	constructor(id = null, label = '', action = '', ordinal = 1) {
		this.id = id;
		this.label = label;
		this.action = action;
		this.ordinal = ordinal;

		this.GUIID = v4();
	}
}